export enum SortOrderEnum {
  ASC = 'asc',
  DESC = 'desc'
}
